// Define a custom web component <find-your-flow>
class FindYourFlow extends HTMLElement {
  constructor() {
    super();

    this.currentStep = 0;
    this.userInputs = {};
    this.isPitlessPicker = this.hasAttribute('data-pitless-picker');

    // Select all flow steps and the buttons that trigger step 1
    this.stepsEle = this.querySelectorAll('flow-step');
    this.nextStepTrigger = this.querySelectorAll('[data-init-flow]');
    this.previousStepTrigger = this.querySelectorAll('[data-flow-back-btn]');

    // DOM references for step 2 options
    this.optTwoEleWrapper = this.querySelector('[data-step-2-content-options]');
    this.optTwoEleHeader = this.querySelector('[data-step-2-content-heading]');
    this.optionTwoData = this.querySelector('[data-step-two-options]');

    // Parse and reformat step 2 option data from JSON if available
    if (this.optionTwoData) {
      let stepTwoJsonData = JSON.parse(this.optionTwoData.textContent)
      this.optionTwoData = {};

      // Populate structured option data for 3 options and their 3 sub-options each
      for (let i = 1; i <= 3; i++) {
        this.optionTwoData[`opt_${i}`] = [];
        for (let j = 1; j <= 3; j++) {
          if (
            stepTwoJsonData[`opt_${i}_heading_${j}`] 
            && stepTwoJsonData[`opt_${i}_image_${j}`] 
            || stepTwoJsonData[`opt_${i}_text_${j}`])
          {
            this.optionTwoData[`opt_${i}`].push({
              main_heading: stepTwoJsonData[`opt_${i}_heading`],
              heading: stepTwoJsonData[`opt_${i}_heading_${j}`],
              image: stepTwoJsonData[`opt_${i}_image_${j}`],
              result: stepTwoJsonData[`opt_${i}_${j}_result`],
              text: stepTwoJsonData[`opt_${i}_text_${j}`],
            });
          }
        }
      }

      // Add optional styling details
      this.optionTwoData.card_bg_color = stepTwoJsonData.card_bg_color;
      this.optionTwoData.card_h_color = stepTwoJsonData.card_h_color;
      this.optionTwoData.card_t_color = stepTwoJsonData.card_t_color;
      
    }

    // Reference for the final result output container
    this.resultDataEle = this.querySelector('[data-result-wrapper-ele]');
  }

  // Lifecycle hook: called when component is added to the DOM
  connectedCallback() {
    // Start the flow when a trigger button is clicked
    this.nextStepTrigger?.forEach(btn => btn.addEventListener('click', (e) => {
      e.preventDefault();
      this.renderNextStep(1);
      this.resetSubmission();
    }));

    this.previousStepTrigger?.forEach(btn => btn.addEventListener('click', (e) => {
      e.preventDefault();
      let step = this.currentStep = this.currentStep-1; 
      this.renderNextStep(step);
    }))

    // Listen to input changes to manage steps progression
    // this.addEventListener('change', this.manageSteps.bind(this));
    
    this.optionSelector(this.querySelectorAll('[name="step-1"]'));
  }

  optionSelector(radios) {
    radios?.forEach(radio => {
      radio.addEventListener('click', this.manageSteps.bind(this));
    });
  }

  // Resets all user inputs and previous result content
  resetSubmission() {
    this.querySelectorAll('input,select,textarea').forEach(e => {
      switch(e.type){
        case 'radio':
        case 'checkbox':
          e.checked = false;
          break;
        case 'select-one':
        case 'select-multiple':
          e.selectedIndex = 0;
          break;
        default:
          e.value = '';
      }
    });

    this.resultDataEle.innerHTML = '';
    this.querySelector('[data-related-product-ele]')?.classList.add('d-none');

    document.querySelector('#site-overlay')?.classList.remove('overlay--body');
    document.querySelector('#site-overlay')?.setAttribute('aria-hidden', true);
    document.body.classList.remove('scroll-fixed');
  }

  // Manages step progression based on current step and user input
  manageSteps() {
    switch (this.currentStep) {
      case 1:
        // Capture selected option for step 1
        this.userInputs.stepOneValue = this.querySelector('input[name="step-1"]:checked').value;
        this.currentStep = 2;
        if (this.isPitlessPicker) {
          this.renderStepTwoPitless();
        } else {
          this.renderStepTwo();
        }
        this.optionSelector(this.querySelectorAll('[name="step-2"]'));
        this.renderNextStep(2);
        break;

      case 2:
        // Capture selected option for step 2
        this.userInputs.stepTwoValue = this.querySelector('input[name="step-2"]:checked').value;
        this.currentStep = 3;
        if (this.isPitlessPicker) {
          this.renderStepThreePitless();
        } else {
          this.renderStepThree();
        }
        this.renderNextStep(3);
        break;
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // Renders the specified step and hides others
  renderNextStep(step) {
    this.stepsEle?.forEach(ele => {
      if (step == ele.dataset.currentStep) {
        ele.classList.remove('d-none');
        ele.classList.add('current-step');
      } else {
        ele.classList.add('d-none');
        ele.classList.remove('current-step');
      }
    });

    this.currentStep = step;
  }

  // Dynamically generates cards for step 2 based on selection from step 1
  renderStepTwo() {
    let html = '';
    let selectedKey = `opt_${this.userInputs.stepOneValue}`;

    if (this.optionTwoData[selectedKey]) {
      if(this.optTwoEleHeader) this.optTwoEleHeader.innerHTML = this.optionTwoData[selectedKey][0].main_heading;
      this.optionTwoData[selectedKey].forEach((item, index) => {
        const id = `step-${item.result.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9\-]/g, '')}`;
        html += `
          <div class="col-md-6 col-lg-4 mt-6">
            <input type="radio" class="d-none" name="step-2" value="${index}" id="${id}">
            <label for="${id}" class="flow-card position-relative rounded-3 overflow-hidden h-100 w-100" style="background: ${this.optionTwoData.card_bg_color};">
              <div class="card-img overflow-hidden">
                ${item.image ? `<img src="${item.image}" />` : ''}
              </div>
              <div class="card-body p-4">
                <h4 class="mb-0" style="color: ${this.optionTwoData.card_h_color};">${item.heading}</h4>
                ${item.text ? `<div class="mt-2 fs-sm" style="color: ${this.optionTwoData.card_t_color};">${item.text}</div>` : ''}
              </div>
            </label>
          </div>
        `;
      });
    }

    this.optTwoEleWrapper.innerHTML = html;
  }

  // Dynamically generates cards for step 2 based on selection from step 1 FOR PITLESS PICKER
  renderStepTwoPitless() {
    let html = '';
    let selectedKey = `opt_${this.userInputs.stepOneValue}`;

    if (this.optionTwoData[selectedKey]) {
      if(this.optTwoEleHeader) this.optTwoEleHeader.innerHTML = this.optionTwoData[selectedKey][0].main_heading;
      this.optionTwoData[selectedKey].forEach((item, index) => {
        const id = `step-2-index-${index}`;
        html += `
          <div class="col-sm-6 col-md-4 col-lg-3 mt-6">
            <input type="radio" class="d-none" name="step-2" value="${index}" id="${id}">
            <label for="${id}" class="flow-card position-relative rounded-3 overflow-hidden h-100 p-4 w-100" style="background: ${this.optionTwoData.card_bg_color};">
              <div class="card-img mx-auto">
                ${item.image ? `<img class="img-fluid w-100 h-100 object-fit-cover" src="${item.image}" />` : ''}
              </div>
              <div class="card-body pt-5">
                <h4 class="mb-0" style="color: ${this.optionTwoData.card_h_color};">${item.heading}</h4>
                ${item.text ? `<div class="mt-1 fs-sm" style="color: ${this.optionTwoData.card_t_color};">${item.text}</div>` : ''}
              </div>
            </label>
          </div>
        `;
      });
    }

    this.optTwoEleWrapper.innerHTML = html;
  }

  // Loads and displays the selected product dynamically (step 3)
  async renderStepThree() {
    let selectedKey = `opt_${this.userInputs.stepOneValue}`;
    let selectedProduct = this.optionTwoData[selectedKey];
    selectedProduct = selectedProduct[this.userInputs.stepTwoValue]?.result;

    this._loadQuickShop(selectedProduct).then(data => {
      let parser = new DOMParser();
      let htmlData = parser.parseFromString(data, 'text/html');

      // Inject the product preview HTML
      if (htmlData.querySelector('[data-product-container]')) {
        this.resultDataEle.innerHTML = htmlData.querySelector('[data-product-container]').outerHTML;
      }

      this.loadRelatedProducts(selectedProduct); // Load related products section
      this.updateLozad();                        // Re-init lazy loading
    });
  }

  async renderStepThreePitless() {
    let selectedKey = `opt_${this.userInputs.stepOneValue}`;
    let selectedProduct = this.optionTwoData[selectedKey];
    selectedProduct = selectedProduct[this.userInputs.stepTwoValue]?.result;
    
    if (!selectedProduct) {return false}

    this._loadPitlessPickerCollection(selectedProduct).then(data => {
      let parser = new DOMParser();
      let htmlData = parser.parseFromString(data, 'text/html');
      // Inject the product preview HTML
      if (htmlData.querySelector('.content-for-layout')) {
        this.resultDataEle.innerHTML = htmlData.querySelector('.content-for-layout').outerHTML;
        if(this.querySelector('storefront-filters')) {
          this.querySelector('storefront-filters').setAttribute('data-url',`/collections/${selectedProduct}?view=find-your-pitless-picker`);
          this.querySelector('storefront-filters').setAttribute('data-no-hash', `/collections/${selectedProduct}?view=find-your-pitless-picker`);
        }
      }

      collapsiblePanel?.init();
      this.updateLozad();
    });
  }

  // Loads related products from a product page and injects them into the component
  async loadRelatedProducts(handle) {
    let url = '';

    await fetch(`/products/${handle}`)
      .then(res => res.text())
      .then(data => {
        let parser = new DOMParser();
        let html = parser.parseFromString(data, 'text/html');
        url = html.querySelector('.related-product-section product-recommendations')?.dataset.url;
      });

    let element = this.querySelector('[data-related-product-main-ele]');
    let html = `
      <product-recommendations data-count="0" class="complementary-items d-block toggle-content-wrap"
        data-url="${url}"> 
      </product-recommendations>
    `;

    if (element) element.innerHTML = html;
  }

  // Initializes lozad.js for lazy loading images
  updateLozad() {
    let lazyImageObserver;
    const lozadInterval = setInterval(() => {
      if (typeof lozad == 'function') {
        lazyImageObserver = lozad('.lozad', {
          rootMargin: '50px 0px',
          enableAutoReload: true
        });
        lazyImageObserver.observe();
        clearInterval(lozadInterval);
      }
    }, 500);
  }

  /**
   * Fetches product quick view HTML using the product handle
   * @param {string} handle - Product handle (URL slug)
   * @returns {Promise<string>} - HTML string of the product quick view
   */
  async _loadQuickShop(handle) {
    let requestURL = `/products/${handle}?view=find-your-flow`;
    const response = await fetch(requestURL);
    const quickShopData = await response.text();
    return quickShopData;
  }

  /**
   * Fetches product quick view HTML using the product handle
   * @param {string} handle - Product handle (URL slug)
   * @returns {Promise<string>} - HTML string of the product quick view
   */
  async _loadPitlessPickerCollection(handle) {
    let requestURL = `/collections/${handle}?view=find-your-pitless-picker`;
    const response = await fetch(requestURL);
    const quickShopData = await response.text();
    return quickShopData;
  }
}

// Register the custom element
customElements.define('find-your-flow', FindYourFlow);